<template>
  <div>
    <div class="d-flex justify-space-between align-center mb-4">
      <div class="text-body-2 font-weight-medium black--text">- {{ configTypeTitle }}</div>
      <div class="d-flex justify-end" style="gap: 8px">
        <v-btn outlined @click="onEnableConfig" v-if="disabled">Thiết lập</v-btn>
        <v-btn outlined @click="onDisableConfig" :loading="loading" v-if="!disabled">Huỷ</v-btn>
        <v-btn color="primary" @click="onSave" :loading="loading" v-if="!disabled">Lưu</v-btn>
      </div>
    </div>
    <DateTimeInput :value="deadline" ref="dateTimeInput" :disabled="disabled" />
  </div>
</template>
<script>
import {mapActions, mapGetters} from 'vuex'
import DateTimeInput from './DateTimeInput.vue'
import {get} from 'lodash'

export default {
  components: {DateTimeInput},
  props: {type: String, grade: String, department: String},
  data: () => ({deadline: '', disabled: true, loading: false}),
  computed: {
    ...mapGetters({deadlineItems: 'enrollDeadline/items'}),
    configTypeTitle() {
      return this.type === 'enroll' ? 'Nhập học' : 'Dự khuyết'
    },
  },
  methods: {
    ...mapActions({setDeadline: 'enrollDeadline/setDeadline'}),
    onEnableConfig() {
      this.disabled = false
    },
    onDisableConfig() {
      this.disabled = true
    },
    validate() {
      const deadline = this.$refs['dateTimeInput'].getData()
      if (typeof deadline === 'string' && deadline.length) return deadline
      return ''
    },
    async onSave() {
      const deadline = this.validate()
      if (!deadline.length) return this.$alert.error('Vui lòng nhập đầy đủ ngày giờ cho "Hạn đăng ký"')

      try {
        this.loading = true
        await this.setDeadline({
          type: this.type,
          deadline,
          grade: this.grade,
          department: this.department,
          isScheduled: true,
        })
        this.onDisableConfig()
        this.$alert.success(
          `Thiết lập "Hạn đăng ký" cho ${this.configTypeTitle} đối với ${this.grade}, ${this.department} thành công!`,
        )
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.loading = false
      }
    },
  },
  watch: {
    deadlineItems: {
      handler(v) {
        if (Array.isArray(v) && v.length) {
          const found = v.find(i => i.type === this.type && i.department === this.department && i.grade === this.grade)
          this.deadline = get(found, 'deadline', '')
        }
      },
      immediate: true,
      deep: true,
    },
  },
}
</script>